import { Logo } from '~/components/logo.tsx'
import { type LogoCloudsFragment } from '~/model/api.ts'

type LogoItem = {
  title: string
  image: string
  link?: string
}

type LogoCloudsProps = {
  title: string
  logos: LogoItem[]
}

export function prepareLogoCloudsProps(
  data: LogoCloudsFragment,
): LogoCloudsProps {
  const validLogos = data.logos.filter(
    (logo): logo is NonNullable<typeof logo> =>
      Boolean(logo?.title && logo?.image?.data?.attributes?.url),
  )

  return {
    title: data.logoCloudsTitle,
    logos: validLogos.map((logo) => ({
      title: logo.title,
      image: logo.image.data?.attributes?.url ?? '',
      link: logo.link ?? '',
    })),
  }
}

export function LogoClouds({ title, logos }: LogoCloudsProps) {
  return (
    <div className="bg-background-inset">
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-20 lg:px-8">
        <h2 className="text-base text-center font-semibold text-global-white">
          {title}
        </h2>
        <div className="mx-auto mt-10 grid grid-cols-2 justify-items-center gap-x-8 gap-y-10 md:auto-cols-fr md:grid-flow-col">
          {logos.map((logo) => (
            <Logo
              key={logo.title}
              title={logo.title}
              image={logo.image}
              link={logo.link}
              className="max-h-12 w-32"
            />
          ))}
        </div>
      </div>
    </div>
  )
}
